import { Directive, TemplateRef, ViewContainerRef, computed, effect, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { SharedUserService } from '../services/shared-user.service'

@Directive({
  selector: '[hasAtLeastOneAgropilotPermission]',
})
export class HasAtLeastOneAgropilotPermissionDirective {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef)
  private viewContainer = inject(ViewContainerRef)
  private readonly user = toSignal(inject(SharedUserService).user, { requireSync: true })

  private readonly hasAnyPermission = computed(() => (this.user()?.agropilotRole?.length ?? 0) > 0)

  constructor() {
    // `hasAnyPermission` only notifies when the boolean flips, so the view is not rebuilt when the user is re-emitted
    effect(() => {
      this.viewContainer.clear()
      if (this.hasAnyPermission()) {
        this.viewContainer.createEmbeddedView(this.templateRef)
      }
    })
  }
}
